exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-check.invoice[data-v-557eae34] {\n    margin-top: 0px;\n}\ntr.summary th[data-v-557eae34], tr.summary td[data-v-557eae34] {\n    font-size: 0.9em;\n}\n", ""]);

// exports
